module.exports = __webpack_public_path__ + "static/2-9fcd025ed4d7f8e365a30e96096006dd.png";